import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DetalleConvocatoriaPostulacionesDTO, DetalleConvocatoriaValidacionPostulacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class DetalleConvocatoriaValidacionPostulacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getDetalleConvocatoriaValidacionPostulacionService(): Observable<BodyListResponse<DetalleConvocatoriaValidacionPostulacionDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaValidacionPostulacionDTO>>(API_URL + '/api/v1/detalleConvocatoriaValidacionPostulacion/todos');
  }

  guardarDetalleConvocatoriaValidacionPostulacionService(detalleConvocatoriaValidacionPostulacionDTO: DetalleConvocatoriaValidacionPostulacionDTO): Observable<BodyResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaValidacionPostulacion', detalleConvocatoriaValidacionPostulacionDTO);
  }


  obtenerDetalleValidacionPostulacionServicePorDetallePostulaciones(codigoDetallePostulacion: string): Observable<BodyListResponse<DetalleConvocatoriaValidacionPostulacionDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaValidacionPostulacionDTO>>(API_URL + '/api/v1/detalleConvocatoriaValidacionPostulacion/detallePostulacion/' + codigoDetallePostulacion);
  }

}
